<template>
  <div class="admin-container">
    <el-container>
      <el-aside width="200px">
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#545c64">
          <el-menu-item>
            <router-link to="/ControlPanel/Intro"><i class="el-icon-menu"></i>信息更新</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/ControlPanel/Email"><i class="el-icon-document"></i>群发邮件</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/ControlPanel/Report"><i class="el-icon-setting"></i>上传报告</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/ControlPanel/ReportManagement"><i class="el-icon-setting"></i>行业报告管理</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="#"><i class="el-icon-setting"></i>用户权限管理</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/ControlPanel/DataManagement"><i class="el-icon-setting"></i>数据管理</router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="#"><i class="el-icon-setting"></i>网站统计</router-link>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>    
  </div>
</template>

<script>
export default {
  data(){
    return{
      //defaultactive: ''
    }
  },
  mounted(){
    if(!this.getLocalStorage('admintoken')){
      this.$router.push({ path: "/Admin" })
    }
  }
}
</script>
